"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PUBLIC_SITE_ORIGINS = exports.HOME = void 0;
exports.buildQueryString = buildQueryString;
exports.canAccessBeta = canAccessBeta;
exports.canUseDOM = void 0;
exports.escapeHTML = escapeHTML;
exports.fixQAPodId = fixQAPodId;
exports.getAPIEndpoint = void 0;
exports.getAppCenterPathName = getAppCenterPathName;
exports.getCanonicalLink = getCanonicalLink;
exports.getCountryCode = getCountryCode;
exports.getHreflangLinks = getHreflangLinks;
exports.getNuiBaseUrlFromHost = getNuiBaseUrlFromHost;
exports.getNuiLanguage = getNuiLanguage;
exports.isClient = void 0;
exports.isInvalidID = isInvalidID;
exports.isPublic = isPublic;
exports.isPublicHost = isPublicHost;
exports.mapCountryToPublicLang = mapCountryToPublicLang;
exports.normalizeMailto = normalizeMailto;
exports.sanitizeOriginalHost = sanitizeOriginalHost;
exports.sendPublicView = sendPublicView;
var _config = _interopRequireDefault(require("../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var HOME = exports.HOME = 'home';
var isClient = exports.isClient = function isClient() {
  return typeof document !== 'undefined';
};
var PUBLIC_SITE_ORIGINS = exports.PUBLIC_SITE_ORIGINS = Object.freeze(['concur.co.jp', 'concur.co.uk', 'concur.com.au', 'concur.de', 'concur.com', 'concur.ca', 'concur.com.mx', 'concur.cn', 'concur.kr', 'concur.com.hk', 'concur.co.in', 'concur.com.sg']);

// Domain Mapping to Constants
var _PUBLIC_SITE_ORIGINS = _slicedToArray(PUBLIC_SITE_ORIGINS, 12),
  CONCUR_DOMAIN_JP = _PUBLIC_SITE_ORIGINS[0],
  CONCUR_DOMAIN_UK = _PUBLIC_SITE_ORIGINS[1],
  CONCUR_DOMAIN_AU = _PUBLIC_SITE_ORIGINS[2],
  CONCUR_DOMAIN_DE = _PUBLIC_SITE_ORIGINS[3],
  CONCUR_DOMAIN_US = _PUBLIC_SITE_ORIGINS[4],
  CONCUR_DOMAIN_CA = _PUBLIC_SITE_ORIGINS[5],
  CONCUR_DOMAIN_MX = _PUBLIC_SITE_ORIGINS[6],
  CONCUR_DOMAIN_CN = _PUBLIC_SITE_ORIGINS[7],
  CONCUR_DOMAIN_KR = _PUBLIC_SITE_ORIGINS[8],
  CONCUR_DOMAIN_HK = _PUBLIC_SITE_ORIGINS[9],
  CONCUR_DOMAIN_IN = _PUBLIC_SITE_ORIGINS[10],
  CONCUR_DOMAIN_SG = _PUBLIC_SITE_ORIGINS[11];
var APP_CENTER_PATH = 'app-center';
var APP_CENTRE_PATH = 'app-centre';
var canUseDOM = exports.canUseDOM = function canUseDOM() {
  return typeof window !== 'undefined' && window.document && window.document.createElement;
};

// db stores them as mailto://<email> or mailto:<email> . The UI wants mailto:email

function normalizeMailto(mailto) {
  if (mailto.startsWith('mailto://')) {
    return "mailto:".concat(mailto.slice(9));
  }
  return mailto;
}

/**
 * Determines if the given ID is invalid, to prevent JS injection
 * @param {string} id id of the listing
 * @returns {string} true if invalid, false if valid
 * @throws will throw if the given url is empty
 */
function isInvalidID(id) {
  if (id === undefined) {
    throw new Error('must provide an ID');
  }
  var re = new RegExp('[^-A-Za-z0-9+&@#/%?=~_$|!:,.;()]');
  return re.test(id);
}
function canAccessBeta(betas, beta) {
  return !!(betas && betas[beta]);
}
var getAPIEndpoint = exports.getAPIEndpoint = function getAPIEndpoint() {
  if (canUseDOM()) {
    return "".concat(_config.default.appcenterAPIBase.client, "/api");
  }
  return "".concat(_config.default.appcenterAPIBase.server, "/api");
};
function buildQueryString(parameters) {
  // TODO: remove this function once node 7.3+ becomes ubiquitous
  var ObjectToArray = function ObjectToArray(x) {
    return Object.keys(x).reduce(function (y, z) {
      return y.push([z, x[z]]) && y;
    }, []);
  };
  var qs = ObjectToArray(parameters).reduce(function (acc, curr) {
    var _curr = _slicedToArray(curr, 2),
      key = _curr[0],
      value = _curr[1];
    if (Object.hasOwnProperty.call(parameters, key)) {
      if (value) {
        return "".concat(acc).concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value), "&");
      }
    }
    return acc;
  }, '');
  if (qs.length > 0) {
    return "?".concat(qs.substring(0, qs.length - 1)); // chop off last "&"
  }
  return '';
}

/**
 * Determines the Country Code that should be used for a given domain.
 * @param {string} url the url the request originates from
 * @returns {string} a Country Code
 * @throws will throw if the given url is empty
 */
function getCountryCode(url) {
  if (!url && url !== '') {
    throw new Error('must provide a url');
  }
  var lowerURL = url.toLowerCase();
  var urlToLang = new Map([[CONCUR_DOMAIN_JP, 'JP'], [CONCUR_DOMAIN_UK, 'GB'], [CONCUR_DOMAIN_AU, 'AU'], [CONCUR_DOMAIN_DE, 'DE'], [CONCUR_DOMAIN_CA, 'CA'], [CONCUR_DOMAIN_MX, 'MX'], [CONCUR_DOMAIN_CN, 'CN'], [CONCUR_DOMAIN_KR, 'KR'], [CONCUR_DOMAIN_HK, 'HK'], [CONCUR_DOMAIN_IN, 'IN'], [CONCUR_DOMAIN_SG, 'SG'], [CONCUR_DOMAIN_US, 'US'] // This has to be last so the match statement below doesn't choose US over MX/AU/HK
  ]);
  if (urlToLang.has(lowerURL)) {
    return urlToLang.get(lowerURL);
  }

  // wasn't an exact match, look for partial match (e.g. concur.com.k8s.cnqr.tech)
  var match = _toConsumableArray(urlToLang.entries()).find(function (elem) {
    return lowerURL.includes(elem[0]);
  });
  return match ? match[1] : 'US';
}
function sanitizeOriginalHost(originalHost) {
  // Fix in the case we get something like:
  // "https://www.concur.com, www.concur.com, www.concur.com, www.concur.com, www.concur.com"
  var splitOriginalHost = originalHost.split(',')[0].trim();

  // Remove 'https://' part of host if it exists
  var splitOriginalHostWithoutHttps = splitOriginalHost.split('https://').pop() || splitOriginalHost;
  return splitOriginalHostWithoutHttps;
}

/**
 * Determines if the given path represents a public version of appcenter
 * @param {string} path the current path e.g. /app-center, /nui/appcenter
 * @returns {boolean} true if public, false if not
 */
function isPublic(path) {
  return /app-center|app-centre/.test(path);
}

/**
 * Determines if the given host is a public appcenter domain
 * @param {string} host e.g. concur.com, concursolutions.com
 * @returns {boolean} true if public, false if not
 * @throws will throw if the given host is empty
 */
function isPublicHost(host) {
  if (!host && host !== '') {
    throw new Error('must provide host');
  }
  var publicDomains = [CONCUR_DOMAIN_JP, CONCUR_DOMAIN_UK, CONCUR_DOMAIN_AU, CONCUR_DOMAIN_DE, CONCUR_DOMAIN_US, CONCUR_DOMAIN_CA, CONCUR_DOMAIN_MX, CONCUR_DOMAIN_CN, CONCUR_DOMAIN_KR, CONCUR_DOMAIN_HK, CONCUR_DOMAIN_IN, CONCUR_DOMAIN_SG];
  return publicDomains.some(function (domain) {
    return host.toLowerCase().endsWith(domain) || host.toLowerCase().endsWith("".concat(domain, ".k8s.cnqr.tech"));
  });
}
function getNuiBaseUrlFromHost(host) {
  return isPublicHost(host) ? APP_CENTER_PATH : _config.default.nui.baseUrl;
}

/**
 * Determines the base path to use for building links
 * @param {string} path the current path e.g. /nui/appcenter/listing/1
 * @returns {string} a base to use for building links e.g. /nui/appcenter
 * @throws will throw if the given path does not match
 */
function getAppCenterPathName(path) {
  var publicRegex = new RegExp(/app-center|app-centre/);
  var privateRegex = new RegExp(/nui\/appcenter/);
  var errorRegex = new RegExp(/404/);
  if (publicRegex.test(path)) {
    return "/".concat(path.match(publicRegex)[0]);
  }
  if (privateRegex.test(path)) {
    return _config.default.nui.baseUrl;
  }
  if (errorRegex.test(path)) {
    return '/404';
  }
  throw new Error("given pathname \"".concat(path, "\" not supported"));
}

/**
 * Determines the language FOR NUI to use for different public appcenter domains
 * @param {string} domain the current domain e.g. concur.co.jp
 * @returns {string} language code, defaults to en e.g. 'jp'
 * @throws will throw if the given domain is empty
 */
function getNuiLanguage(domain) {
  if (!domain && domain !== '') {
    throw new Error('must provide domain');
  }
  var lowerDomain = domain.toLowerCase();
  var domainToLang = new Map([[CONCUR_DOMAIN_JP, 'ja'], [CONCUR_DOMAIN_UK, 'en-gb'], [CONCUR_DOMAIN_AU, 'en-gb'], [CONCUR_DOMAIN_DE, 'de'], [CONCUR_DOMAIN_CA, 'en'], [CONCUR_DOMAIN_MX, 'es-la'], [CONCUR_DOMAIN_CN, 'zh-cn'], [CONCUR_DOMAIN_KR, 'ko'], [CONCUR_DOMAIN_HK, 'en'], [CONCUR_DOMAIN_IN, 'en'], [CONCUR_DOMAIN_SG, 'en'], [CONCUR_DOMAIN_US, 'en'] // This has to be last so match statement doesn't choose this over au/mx/hk/sg
  ]);
  if (domainToLang.has(lowerDomain)) {
    return domainToLang.get(lowerDomain);
  }

  // wasn't an exact match, look for partial match (e.g. concur.com.k8s.cnqr.tech)
  var match = _toConsumableArray(domainToLang.entries()).find(function (elem) {
    return lowerDomain.includes(elem[0]);
  });
  return match ? match[1] : 'en';
}

/**
 * Determines the language FOR PUBLIC WRAPPER to use
 * @param {string} domain the current domain e.g. concur.co.jp
 * @returns {string} language code, defaults to en e.g. 'ja-jp'
 * @throws will throw if the given country is empty
 */
function mapCountryToPublicLang(country) {
  if (!country) {
    throw new Error('must provide country');
  }
  var langMap = {
    DE: 'de-de',
    AU: 'en-au',
    CA: 'en-ca',
    GB: 'en-uk',
    US: 'en-us',
    JP: 'ja-jp',
    SP: 'sp-mx',
    CN: 'zh-hans-cn',
    KR: 'ko-kr',
    HK: 'en-hk',
    IN: 'en-in',
    SG: 'en-sg'
  };
  return langMap[country.toUpperCase()] || 'en-us';
}

/**
 * Determines the public appcenter canonical link should be used based on the host and mapping
 * @param {string} path the current path
 * @return {string} canonical link should use in canonical link tag
 */
function getCanonicalLink(host, location) {
  if (!host) {
    throw new Error('must provide host');
  }
  var appCentreDomains = [CONCUR_DOMAIN_UK, CONCUR_DOMAIN_AU, CONCUR_DOMAIN_CA];
  var appCenterLocation = location.replace(APP_CENTRE_PATH, APP_CENTER_PATH);
  var appCentereLocation = location.replace(APP_CENTER_PATH, APP_CENTRE_PATH);
  return appCentreDomains.some(function (domain) {
    return host.toLowerCase().includes(domain);
  }) ? "https://".concat(host).concat(appCentereLocation) : "https://".concat(host).concat(appCenterLocation);
}

/**
 * In order to do international SEO for public appcenter,
 * we need to push all the public appcenter sites with hreflang tag
 * @param {object[]} path the current path
 * @return {object[]} canonical link should use in canonical link tag
 */
function getHreflangLinks(links, location) {
  var useEnGB = ["https://www.".concat(CONCUR_DOMAIN_AU), "https://www.".concat(CONCUR_DOMAIN_UK), "https://www.".concat(CONCUR_DOMAIN_CA)];
  var hrefs = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "https://www.".concat(CONCUR_DOMAIN_JP), 'ja'), "https://www.".concat(CONCUR_DOMAIN_UK), 'en-gb'), "https://www.".concat(CONCUR_DOMAIN_AU), 'en-au'), "https://www.".concat(CONCUR_DOMAIN_US), 'en-us'), "https://www.".concat(CONCUR_DOMAIN_DE), 'de-de'), "https://www.".concat(CONCUR_DOMAIN_CA), 'en-ca');
  var loc = location.split(/\/(app-centre|app-center)\//)[2] || '';

  /* eslint-disable no-restricted-syntax, guard-for-in */
  for (var href in hrefs) {
    var path = '/app-center/';
    if (useEnGB.includes(href)) {
      path = '/app-centre/';
    }
    links.push({
      rel: 'alternate',
      href: href + path + loc,
      hreflang: hrefs[href]
    });
  }
  /* eslint-enable no-restricted-syntax, guard-for-in */
}

/**
 * Sets page_name and triggers a view metric for public logging (concur.com)
 */
function sendPublicView() {
  if (canUseDOM() && window.getPagePath) {
    var pageName = window.getPagePath('page_name');
    window.utag_data.page_name = pageName;
    window.utag.view({
      page_name: pageName
    });
  }
}

/**
 * Strips out HTML tag characters from provided string
 * @param {string} text the potentially unsafe text to sanitize
 * @returns {string} string with dangerous characters removed
 */
function escapeHTML(text) {
  var map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;'
  };
  return text.replace(/[&<>"]/g, function (m) {
    return map[m];
  });
}

/**
   * This is a hack but to make the QA and Prod identical we need to
   * fix QA user podId to be production US and EMEA podId. For now, we
   * will consider rqa3 as US. Note: This might change
   * in the future.
   *
   * Change rqa3 user podId from 1 -> 0;
   */
function fixQAPodId(podId) {
  var PodConstants = {
    RQA3_POD: 1,
    INT_POD: 1,
    EU_POD: 6,
    US_POD: 0,
    EU2_POD: 13,
    US2_POD: 12
  };
  if ([PodConstants.RQA3_POD, PodConstants.INT_POD, PodConstants.US2_POD].includes(podId)) {
    podId = PodConstants.US_POD;
  }
  if (podId === PodConstants.EU2_POD) {
    podId = PodConstants.EU_POD;
  }
  return podId;
}